import React, { useEffect, useState } from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import {
    dTicketsClearFiltersAC, dTicketsEditItemSagaAC,
    dTicketsSetDataSagaAC, dTicketsSetDetailItemAC,
    dTicketsSetFiltersAC, dTicketsSetMerchantDataSagaAC
} from 'model/dashboardTickets/dTicketsActionCreators';
import { IdTicketsState, IdTicketsStateDataItem, typeTicketsFilters } from 'model/dashboardTickets/dTicketsReducer';
import { ViewDataTickets } from 'components/containers/dashboard/dataTickets/ViewComponent';
import { useInputChange } from 'hooks/useInputChange';
import { TICKETSTATUS } from 'constants/ticketsStatus';
import { ISystemState } from 'model/system/systemReducer';
import { getCookie } from 'utils/utils';


// Type
export type typeTickets = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export type typeDataTicketsRowActions = { title: JSX.Element, action: (id: string) => void }[]


// Component
export const DataTickets: React.FC<typeTickets> = ({ variant, setSidebarOpen }) => {

    const dispatch = useDispatch()

    const merchantIdFromCookie=getCookie('tindaRemoteMerchant')
    const merchantIdFromState= useSelector((state: {
        system: ISystemState
    }) => state.system.userInfo?.authorizedUser.primaryTenant)
    const merchantId = merchantIdFromCookie? merchantIdFromCookie : merchantIdFromState


    // DateFilter
    const [ isActiveFilters, setIsActiveFilters ] = useState(false)
    const [ openFilterBar, setOpenFilterBar ] = useState(false)
    const filters = useSelector((state: { dTickets: IdTicketsState }) => state.dTickets.filters)


    // Did mount & Did unmount
    useEffect(() => {
        return () => {
            dispatch(dTicketsClearFiltersAC())
        }
        // eslint-disable-next-line
    }, [])

    // Did mount & Did unmount
    useEffect(() => {
        if (merchantId) {
            dispatch(dTicketsSetMerchantDataSagaAC(merchantId))
        }
        // eslint-disable-next-line
    }, [merchantId])

    useEffect(() => {
        dispatch(dTicketsSetDataSagaAC(filters))

        // eslint-disable-next-line
    }, [ filters ])

    // Search panel
    const searchUserName = useSelector((state: { dTickets: IdTicketsState }) => state.dTickets.filters?.name)

    const {
        value: searchValue,
        setValue: setSearchValue,
        changeValueHandler: onChangeSearchValue
    } = useInputChange(searchUserName || '')

    const onClearSearch = () => {
        dispatch(dTicketsSetFiltersAC({
                                          name: null
                                      }))
        setSearchValue('')
    }
    const onEnterSearch = () => {
        const filters: typeTicketsFilters = {
            name: searchValue.trim()
        }
        dispatch(dTicketsSetFiltersAC(filters))

    }

    // Current item
    const currentItem = useSelector((state: { dTickets: IdTicketsState }) => state.dTickets.detailItem)

    // Popup details
    const [ openPopupDetails, setOpenPopupDetails ] = useState(false)

    // Popup add
    const [ openPopupAdd, setOpenPopupAdd ] = useState(false)


    // Delete dialog
    const [ openCancelledDialog, setOpenCancelledDialog ] = useState(false)

    // Delete dialog actions
    const onCancelledCancelHandler = () => {
        setOpenCancelledDialog(false)
    }
    const onCancelledConfirmHandler = async () => {
        const dataEditObject: IdTicketsStateDataItem = {
            status: TICKETSTATUS.CANCELLED,
            id: currentItem!.id,

        }
        await dispatch(dTicketsEditItemSagaAC(dataEditObject, filters))

        setOpenCancelledDialog(false)
    }


    // Make table item actions
    const rowsActions = [

        {
            id: 'changeStatus',
            title: <Trans>Cancel ticket</Trans>,
            action: (id: string) => {
                dispatch(dTicketsSetDetailItemAC(id))
                setOpenCancelledDialog(true)
            }

        }
    ]

    return (
        <ViewDataTickets

            variant={ variant }
            setSidebarOpen={ setSidebarOpen }

            openFilterBar={ openFilterBar }
            setOpenFilterBar={ setOpenFilterBar }

            openPopupDetails={ openPopupDetails }
            setOpenPopupDetails={ setOpenPopupDetails }

            openPopupAdd={ openPopupAdd }
            setOpenPopupAdd={ setOpenPopupAdd }

            openDeleteDialog={ openCancelledDialog }
            setOpenDeleteDialog={ setOpenCancelledDialog }
            onDeleteConfirmHandler={ onCancelledConfirmHandler }
            onDeleteCancelHandler={ onCancelledCancelHandler }

            searchValue={ searchValue }
            onChangeSearchValue={ onChangeSearchValue }
            onEnterSearch={ onEnterSearch }
            onClearSearch={ onClearSearch }

            rowsActions={ rowsActions }

            currentItem={ currentItem }

            isActiveFilters={ isActiveFilters }
            setIsActiveFilters={ setIsActiveFilters }
        />

    )
}
